import React, { memo, useCallback, useState } from "react";
import stylesPc from "./FeaturedContentCard.module.css";
import stylesSp from "./FeaturedContentCard_SP.module.css";
import { IsDevice } from "../../../../components/function/useDeviceFlag";
import { useHistory } from "react-router-dom";
import { SpacedList, SpacedListItem } from "../../../../common/components/spacedList/SpacedList";
import { VideoTag } from "../../../../common/video/models/VideoTag";
import Tag from "../../../../common/components/tag/Tag";
import VideoMenu from "../../../../common/components/videoMenu/VideoMenu";
import EditAndUploadToHubModal from "../../../../components/widgets/EditAndUploadToHubModal";
import PuiTooltip from "../../../../components/elements/PuiTooltip ";
import PuiTypography from "../../../../components/elements/PuiTypography";
import EditSlideStock from "../../../videoPlayer/components/slideStockEdit/EditSlideStock";
import { MoreVert } from "@material-ui/icons";
import {
    HideVideoAdminBtn,
    ShowVideoAdminBtn,
    isAdmin,
    isEditor,
} from "../../../../utils/LogicUtils";
import { useSelector } from "react-redux";
import { AppState } from "../../../../root/RootReducer";

interface ContentCardProps {
    content: any;
    setMsg: (msg: string) => void;
}

function FeaturedContentCard({ content, setMsg }: ContentCardProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;
    const history = useHistory();

    // ユーザー取得
    const { user } = useSelector((state: AppState) => ({
        user: state.user.user,
    }));

    const goToContent = useCallback(() => {
        if (content.fileType) {
            history.push(`/slidestock/${content.id}`);
        } else {
            history.push(`/video/${content.id}`);
        }
    }, [content, history]);

    //コンテンツ管理者編集ボタン表示フラグ
    const [isShowMore, setIsShowMore] = useState<boolean>(false);

    return (
        <div className={styles.card}>
            <div
                className={styles.thumbnaildiv}
                onMouseEnter={ShowVideoAdminBtn}
                onMouseLeave={HideVideoAdminBtn}
            >
                <img
                    className={styles.thumbnail}
                    src={content.imageUrl}
                    alt=""
                    onClick={goToContent}
                    onError={(e) =>
                        (e.currentTarget.src =
                            require("../../../../assets/image/NoImage.jpg").default)
                    }
                />

                {(isAdmin(user?.roles) || isEditor(user?.roles)) && (
                    <div onClick={() => setIsShowMore(!isShowMore)} className={styles.moreIcon}>
                        <MoreVert />
                    </div>
                )}

                {isShowMore && (
                    <>
                        <div
                            className={styles.menuItem}
                            style={{ height: !content.fileType ? "88px" : "60px" }}
                        >
                            <div className={styles.editVideoIcon}>
                                {/* ビデオ編集ボタン */}
                                {!content.fileType && <EditAndUploadToHubModal video={content} />}
                            </div>

                            {/* コンテンツ編集ボタン表示 */}
                            {content.fileType && (
                                <div className={styles.editSlideIcon}>
                                    <EditSlideStock slideId={content.id} />
                                </div>
                            )}
                            <div>
                                {!content.fileType && (
                                    <VideoMenu
                                        video={content}
                                        videoId={content.id}
                                        setMsg={setMsg}
                                    />
                                )}
                            </div>
                        </div>
                        <div
                            className={styles.selectOtherArea}
                            onClick={() => setIsShowMore(false)}
                        />
                    </>
                )}

                {/* 新規ビデオアイコン */}
                {content.visibleNewIcon && (
                    <img
                        src={require("../../../../assets/image/newIcon.svg").default}
                        className={styles.newIcon}
                        alt={`newIcon_${content.id}`}
                    />
                )}
            </div>

            <div className={styles.text} onClick={goToContent}>
                <div className={styles.textBody}>
                    <div className={styles.presenter}>
                        <div className={styles.presenterIcon}>
                            <img
                                src={content.professionalImageUrl}
                                className={styles.presenterIcon}
                                alt={content.id}
                                onError={(e) =>
                                    (e.currentTarget.src =
                                        require("../../../../../src/assets/image/noPresenterImage.svg").default)
                                }
                            />
                        </div>

                        <PuiTypography>
                            {/* {`${content.presenter}`} */}
                            {` ${content.presenter}`}
                        </PuiTypography>
                    </div>

                    <div className={styles.title}>
                        <div
                            className={styles.thumbnailTitle}
                            data-for="title"
                            data-tip={content.title}
                        >
                            <PuiTypography size={20}>{content.title}</PuiTypography>
                        </div>
                    </div>
                    <PuiTooltip id="title" />

                    <div className={styles.description}>
                        <div
                            className={styles.thumbnailDescription}
                            data-for="description"
                            data-tip={content.description}
                        >
                            <PuiTypography>{content.description}</PuiTypography>
                        </div>
                    </div>
                    <PuiTooltip id="description" />
                </div>

                <div className={styles.meta}>
                    {content.tags && content.tags.length > 0 && (
                        <SpacedList>
                            {content.tags.map((tag: VideoTag) => (
                                <SpacedListItem key={tag}>
                                    <Tag tag={tag} />
                                </SpacedListItem>
                            ))}
                        </SpacedList>
                    )}
                </div>
            </div>

            {/* <div className={styles.slideBtn}>
                <LibraryBooksIcon style={{color: "var(--red)"}} />
            </div>    */}
        </div>
    );
}

export default memo(FeaturedContentCard);
